import React from 'react';
import PropTypes from 'prop-types';
import classes from 'classnames';
import {withRouter} from 'react-router-dom';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import dateArray from 'moment-array-dates';
import Toggle from 'react-toggle';
import 'react-toggle/style.css';
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import routeSettings from '../../../../config/router';
import {round} from '../../../../utils/func';
import {Button, buttonTypes} from "../../../../components/Button/index";
import ImgBlock from './Image';


class Block extends React.Component {
  constructor(props) {
    super(props);
    this.handleChangePeoples = this.handleChangePeoples.bind(this);
    this.state = {
      error: {},
      availableDaysArr: [],
      availableDays: [],
      offDays: [],
      transportationPriceOnePerson: 0,
      timeSlotsOptions: [],
      personsOptions: [],
      persons: 0,
      date: null,
      timeSlotId: null,
      guide: false,
      staffPrice: null,
      totalPrice: 0,
    }
  }

  static propTypes = {
    history: PropTypes.object,
    id: PropTypes.number,
    tourPhotos: PropTypes.array,
    title: PropTypes.string,
    priceOnePerson: PropTypes.number,
    minPersons: PropTypes.number,
    maxPersons: PropTypes.number,
    dayOff: PropTypes.array,
    tourDates: PropTypes.array,
    changeTourData: PropTypes.func,
    vehicle: PropTypes.object,
    selectedData: PropTypes.object,
    deleteFromCart: PropTypes.func,
    cityId: PropTypes.number,
    cities: PropTypes.array,
    onPrices: PropTypes.func,
  };

  componentWillMount() {
    const d = this.props.selectedData;
    this.setState({
      persons: d.persons,
      date: moment(d.date),
      timeSlotId: d.timeSlotId,
      guide: d.guide,
      staffPrice: this.getStaffPrice(this.props),
    }, () => {
      this.setAvailDays();
      this.setTransportationPrice();
      this.minMaxPeopleOptions();
      setTimeout(() => {
        this.handleChangeDate(moment(d.date))
      }, 200)
    });
  }

  componentWillReceiveProps(next) {
    // console.log(next.vehicle.prices)
    this.setState({staffPrice: this.getStaffPrice(next)}, () => {
      if (!this.state.totalPrice)
        this.calculate();
    })
  }

  setTransportationPrice = () => {
    const {prices} = this.props.vehicle;
    const {persons} = this.state;
    let result = 0;
    if (prices && prices.length > 0 && persons) {
      for (let i = 0; i < prices.length; i++) {
        if (persons >= prices[i].minPersons && persons <= prices[i].maxPersons) {
          result = prices[i].priceOnePerson;
          break;
        }
      }
      // console.log('CHECK RES', result);
      if (!result) {
        for (let i = 0; i < prices.length; i++) {
          if (result < prices[i].priceOnePerson) {
            result = prices[i].priceOnePerson;
          }
        }
        for (let i = 0; i < prices.length; i++) {
          if (result > prices[i].priceOnePerson) {
            result = prices[i].priceOnePerson;
          }
        }
      }
      this.setState({transportationPriceOnePerson: result}, () => {
        this.calculate();
      });
      return result;
    }
    return 0;
  };

  setAvailDays = () => {
    const result = [];
    const days = this.props.tourDates;

    if (days && days[0]) {
      const daysInArr = [];
      for (let i = 0; i < days.length; i++) {
        let isAdd = true;
        for (let k = 0; k < daysInArr.length; k++) {
          if (daysInArr[k] === days[i].weakDay) {
            isAdd = false;
          }
        }
        if (isAdd)
          daysInArr.push(days[i].weakDay)
      }

      if (daysInArr.length > 0) {
        for (let i = 0; i < daysInArr.length; i++) {
          let day = 0;
          if (+daysInArr[i] === 6) {
            day = 0
          } else {
            day = +daysInArr[i] + 1
          }
          const start = moment().day(-1);
          const end = moment().add(1.1, 'Y');
          const current = start.clone();

          while (current.day(7 + day).isBefore(end)) {
            if (moment(current.clone(), 'YYYY-MM-DD HH:mm') > moment())
              result.push(current.clone());
          }
        }
      }
    }
    const availableDaysArr = result.map(m => m.format('YYYY-MM-DD'));
    this.setState({availableDaysArr, availableDays: result});
    this.setOffDays(this.props.dayOff, availableDaysArr);
  };

  setOffDays = (offDays, availableDaysArr) => {
    const daysBy2Years = dateArray.range(moment().date(-20), moment().add(1.1, 'Y'), 'YYYY-MM-DD');
    const result = [];
    if (offDays && offDays.length)
      for (let i = 0; i < offDays.length; i++) {
        result.push(moment(offDays[i]))
      }
    for (let i = 0; i < daysBy2Years.length; i++) {
      let isAdd = true;
      for (let k = 0; k < availableDaysArr.length; k++) {
        if (daysBy2Years[i] === availableDaysArr[k]) {
          isAdd = false
        }
      }
      if (isAdd)
        result.push(moment(daysBy2Years[i]))
    }
    this.setState({offDays: result});
  };

  minMaxPeopleOptions = () => {
    const min = this.props.minPersons;
    const max = this.props.maxPersons;
    const result = [];
    for (let i = min; i <= max; i++) {
      result.push({value: i, label: i})
    }
    this.setState({personsOptions: result});
  };

  handleChangePeoples(e) {
    this.setState({persons: e.value, error: {...this.state.error, persons: ''}}, () => {
      this.setTransportationPrice();
      this.changeTourData();
      this.calculate();
    })
  }

  handleChangeDate = (e) => {
    if (e && moment().diff(e, 'days') <= 0) {
      let isAvailableDay = false;
      this.state.availableDaysArr.map((day) => {
        if (day === e.format('YYYY-MM-DD')) {
          isAvailableDay = true;
        }
        return true;
      });
      if (isAvailableDay) {
        const weakDay = e.isoWeekday() - 1;
        const {tourDates} = this.props;
        const timeSlotsOptions = [];
        for (let i = 0; i < tourDates.length; i++) {
          if (+tourDates[i].weakDay === +weakDay) {
            timeSlotsOptions.push({
              value: tourDates[i].id,
              label: `${tourDates[i].startTime} - ${tourDates[i].endTime}`
            })
          }
        }
        if (timeSlotsOptions.length > 0)
          this.setState({date: e, timeSlotsOptions, error: {...this.state.error, date: ''}}, () => {
            this.changeTourData()
          })
      } else {
        this.setState({error: {...this.state.error, date: 'Make a choice of available dates'}})
      }
    } else
      this.setState({date: null, timeSlotsOptions: []})
  };

  handleChangeTime = (e) => {
    if (e)
      this.setState({timeSlotId: e.value, error: {...this.state.error, time: ''}}, () => {
        this.changeTourData();
        this.calculate();
      })
  };

  handleChangeGuide = () => {
    this.setState({guide: !this.state.guide}, () => {
      this.changeTourData();
      this.calculate();
    })
  };

  changeTourData = () => {
    const {
      persons,
      date,
      timeSlotId,
      guide,
    } = this.state;
    if (!date) {
      this.setState({error: {date: 'Pleas Select Date'}})
    } else if (!persons) {
      this.setState({error: {persons: 'Select the number of people'}})
    } else if (!timeSlotId) {
      this.setState({error: {time: 'Select time'}})
    } else {
      this.props.changeTourData({id: this.props.id, persons, date: date.format('YYYY-MM-DD'), timeSlotId, guide})
    }
  };

  deleteFromCart = () => {
    this.props.deleteFromCart(this.props.id, true)
  };

  calculate = () => {
    const {
      persons,
      transportationPriceOnePerson,
      guide,
      staffPrice
    } = this.state;

    const {id} = this.props;

    // console.log(this.props.priceOnePerson, transportationPriceOnePerson, persons)

    let result = (this.props.priceOnePerson * persons) + (persons * transportationPriceOnePerson);
    if (guide && staffPrice) {
      result += staffPrice
    }
    this.props.onPrices({
      [id]: {
        tour: this.props.priceOnePerson * persons,
        transport: transportationPriceOnePerson * persons,
        total: result
      }
    });
    this.setState({totalPrice: round(result)});
    return round(result);
  };

  getStaffPrice = (props) => {
    const {cities, cityId} = props;
    if (cities && cities.length) {
      for (let i = 0; i < cities.length; i++) {
        if (cities[i].id === cityId) {
          return cities[i].staffPrice;
        }
      }
    }
    return null;
  };

  render() {

    const {
      id,
      title,
      tourPhotos,
      priceOnePerson,
      history,
    } = this.props;

    const {
      timeSlotsOptions,
      personsOptions,
      timeSlotId,
      persons,
      date,
      guide,
      error,
      availableDays,
      transportationPriceOnePerson,
      offDays,
      staffPrice,
      totalPrice,
    } = this.state;

    const className = classes('add-cart__group add-cart__footer', {noStaff: !staffPrice});

    return (
      <div className="cart__item">
        <div className="cart__item-header">
          <ImgBlock
            title={title}
            images={tourPhotos}
            onClick={() => history.push(`${routeSettings.tourPage}/${id}`)}
          />
          <div className="cart__item-wrap">
            <div className="add-cart__block input-block">
              <div className="add-cart__select-block">
                <p className="add-cart__select-label">Select date</p>
                <DatePicker
                  selected={date}
                  onChange={this.handleChangeDate}
                  excludeDates={offDays}
                  highlightDates={[
                    {
                      "react-datepicker__day--highlighted-custom-2": availableDays
                    }
                  ]}
                  placeholderText="Select date"
                  minDate={moment().date(-20)}
                  maxDate={moment().add(1, "Y")}
                />
                {error.date && <span className="error-block">{error.date}</span>}
              </div>
              <div className="add-cart__select-block">
                <p className="add-cart__select-label">Select time</p>
                <Select
                  placeholder="Select Time"
                  name="timeSlot"
                  value={timeSlotId}
                  onChange={this.handleChangeTime}
                  clearable={false}
                  options={timeSlotsOptions}
                />
                {error.time && <span className="error-block">{error.time}</span>}
              </div>
            </div>
            <div className="add-cart__block">
              <p className="add-cart__block-row">
                Price/person<span>$ {round(priceOnePerson + transportationPriceOnePerson, 2)}</span>
              </p>
              {/* <p className="add-cart__block-row">Transportation price<span> {transportationPriceOnePerson} $</span></p> */}
              <div className="add-cart__select-block add-cart__block-row">
                <p className="add-cart__select-label">Number of attendees</p>
                <Select
                  placeholder="0"
                  name="persons"
                  value={persons}
                  onChange={this.handleChangePeoples}
                  clearable={false}
                  options={personsOptions}
                />
                {error.persons && <span className="error-block">{error.persons}</span>}
              </div>
              {
                staffPrice ?
                  <div className="toggle-block add-cart__block-row">
                    <p className="toggle-block__label">We need a staff person</p>
                    <div className="toggle-block__wrap">
                      <Toggle
                        checked={guide}
                        icons={false}
                        onChange={this.handleChangeGuide}
                      />
                    </div>

                  </div> : null
              }
            </div>
          </div>
        </div>
        <div className={className}>

          {persons && <p className="add-cart__total-price">Price <span> $ {totalPrice}</span></p>}
        </div>
        <div className="cart__buttons">
          <Button
            className="button__icon ion-close-round"
            type={buttonTypes.AUTHENTICATION}
            onClick={this.deleteFromCart}
          />
        </div>
      </div>
    )
  }
}

export default withRouter(Block);


// WEBPACK FOOTER //
// ./src/app/containers/Cart/components/Block/index.js